<template>
  <div class="md:flex min-h-screen w-full">
    <div class="w-full md:w-1/2 bg-white flex items-center justify-center">
      <div class="max-w-sm m-8">
        <div class="mb-16">
          <v2-icon :data="require('@icon/logo.svg')" fill color="#5057af" width="100%" height="auto"></v2-icon>
          <!-- Christmas edition-->
          <!-- <img src="@/assets/img/envivo-christmas-blue.png" alt="logo" style="height: auto; width: 100%"/>-->
        </div>
        <div class="text-black text-5xl md:text-15xl font-black">404</div>
        <div class="w-16 h-1 my-3 md:my-6 envivo-color"></div>
        <p class="text-gray-darker text-2xl md:text-3xl font-light mb-8 leading-normal">
          {{ $t("errors.pageNotFound.error") }}
        </p>
        <v-button primary fullWidth @click.native="$goTo('StaticLogin')">{{ $t("errors.pageNotFound.goTo") }}</v-button>
        <div class="mb-16">
          <p class="text-gray-darker text-1xl md:text-3xl font-light leading-normal">powered by envivo</p>
        </div>
      </div>
    </div>
    <div class="bg-image relative pb-full md:flex md:pb-0 md:min-h-screen w-full md:w-1/2"></div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    __(text) {
      return text;
    },
  },
};
</script>

<style scoped>
.envivo-color {
  background-color: #343e93;
}
</style>
